export function faqAccordion() {
    const accordion = $(".faq-accordion");
    const accordionItem = accordion.find(".faq-item");
    init();
    function init() {
        if (accordionItem.length) {
            if (accordion.hasClass("two-column")) splitColumns();
            // setFirstActive();
            setEvents();
        }
    }
    function splitColumns() {
        accordionItem.filter((i, el) => i < accordionItem.length / 2).wrapAll("<div class='column'></div>");
        accordionItem.filter((i, el) => i >= accordionItem.length / 2).wrapAll("<div class='column'></div>");
    }
    function setFirstActive() {
        accordionItem.eq(0).addClass("active")
            .find(".faq-item-body").css({
                display: "block"
            });
    }
    function setEvents() {
        accordionItem.on("click", ".faq-item-head", function (e) {
            controlActive(this);
        });
    }
    function controlActive(el) {
        let $item = $(el).closest(".faq-item");
        if (!$item.hasClass("active")) {
            accordionItem.not($item).removeClass("active").find(".faq-item-body").slideUp();
        }
        $item.toggleClass("active").find(".faq-item-body").slideToggle();
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/faqAccordion.js